import * as ss from 'superstruct';

export const OrgDto = ss.type({
  id: ss.number(),
  tz: ss.string(),
  name: ss.string(),
});

export type OrgDto = ss.Infer<typeof OrgDto>;
